export const learnMoreLinkUrl =
	'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-request-types/';
